function Footer () 
{
    return(
        <div id="footer">
            <p>Self Made</p>
        </div>
    )
}

export default Footer